import type { EstimateOption } from "../interfaces/payout";

/**
 * Catalog funding methods (UPPER_SNAKE). Mirrors the canonical list in
 * raas-widgets-backend. These are the ways the SENDER can pay for the transfer.
 */
export const FUNDING_METHODS = [
  "DEBIT_CARD",
  "CREDIT_CARD",
  "ACH",
  "RTP",
  "WALLET",
  "CASH_DEPOSIT",
  "BANK_BALANCE",
] as const;
export type FundingMethod = (typeof FUNDING_METHODS)[number];

export const PAYOUT_METHODS = [
  "CASH_PICKUP",
  "BANK_ACCOUNT",
  "PUSH_TO_CARD",
  "MOBILE_WALLET",
  "HOME_DELIVERY",
] as const;
export type PayoutMethod = (typeof PAYOUT_METHODS)[number];

export type FundingCategory = "CARD" | "ACCOUNT" | "CASH" | "OTHER";

export const FUNDING_METHOD_CATEGORY: Record<FundingMethod, FundingCategory> = {
  DEBIT_CARD: "CARD",
  CREDIT_CARD: "CARD",
  ACH: "ACCOUNT",
  RTP: "ACCOUNT",
  BANK_BALANCE: "ACCOUNT",
  WALLET: "OTHER",
  CASH_DEPOSIT: "CASH",
};

export function categoryFromFundingMethod(
  method: string | undefined | null
): FundingCategory | undefined {
  if (!method) return undefined;
  const upper = method.toUpperCase();
  if (upper in FUNDING_METHOD_CATEGORY) {
    return FUNDING_METHOD_CATEGORY[upper as FundingMethod];
  }
  switch (method) {
    case "card":
      return "CARD";
    case "bank_account":
      return "ACCOUNT";
    case "cash":
      return "CASH";
    default:
      return undefined;
  }
}

export function availableFundingMethods(
  options: EstimateOption[]
): FundingMethod[] {
  const seen = new Set(options.map((o) => o.fundingMethod));
  return FUNDING_METHODS.filter((m) => seen.has(m));
}

export function optionForFundingMethod(
  options: EstimateOption[],
  method: FundingMethod
): EstimateOption | undefined {
  return options
    .filter((o) => o.fundingMethod === method)
    .sort((a, b) => a.sendAmount - b.sendAmount)[0];
}
